import 'gsap';
import noop from 'lodash/noop';
import Game from './Game';
import BootState from './states/Boot';
// import VictoryBoot from './states/VictoryBoot';

const defaultProps = {
  // isDesktop: false,
  // onSpin: noop,
  // resolution: 1,
  // unlockTime: null,
  // freeTicketsRemaining: 0,
  // spinsRemaining: 0,
};

function create(parent, props = {}) {
  const WORLD_WIDTH = props.isDesktop ? 950 : 714;
  const WORLD_HEIGHT = props.isDesktop ? 600 : 600;

  const initialProps = {
    ...defaultProps,
    ...props,
  };
  const config = {
    transparent: true,
    width: WORLD_WIDTH,
    height: WORLD_HEIGHT,
    parent,
    resolution: initialProps.resolution,
    state: BootState,
    renderer: Phaser.AUTO,
  };

  const game = new Game(config, initialProps);
  return game;
}

// function createVictory(parent, props = {}) {
//   const WORLD_WIDTH = props.isDesktop ? 1300 : 850;
//   const WORLD_HEIGHT = props.isDesktop ? 750 : 1400;
//
//   const initialProps = {
//     ...defaultProps,
//     ...props,
//   };
//   const config = {
//     transparent: true,
//     width: WORLD_WIDTH,
//     height: WORLD_HEIGHT,
//     parent,
//     resolution: initialProps.resolution,
//     state: VictoryBoot,
//     renderer: Phaser.CANVAS,
//   };
//
//   const game = new Game(config, initialProps);
//   return game;
// }

export default {
  create,
  // createVictory,
};
